import { copyText } from "../../utils/CopyGraphToClipBoard";
import React, { useId } from "react";
import { useMyContext } from "../../context/DataContext";
import './ResponseBox.css';
import Mail from "../Mail/Mail";
import KgGraphPopup from "./KgGraphPopup";
import ToolTipComponent from "../Tooltip/ToolTipComponent";
import { useToolTip } from "../Tooltip/ToolTip";
import FeedbackPopup from "../FeedbackPopup/Feedbcakpopup";
import { useAuth0 } from "@auth0/auth0-react";
import ChatApiServices, { getDocumentLinksByFilename } from "../../services/AxiosServices";


interface MessageFooterProps {
  message?: any;
  copyToClipBoard?: (e: any) => void;
  handleShareClick?: (e: any) => void;
  type?: string;
  isKgraph?: boolean;
  isKgChat?: boolean;
}
const MessageFooter: React.FC<MessageFooterProps> = ({
  message,
  copyToClipBoard,
  type,
  isKgraph,
  isKgChat = false,
}) => {
  const { updateState } = useMyContext();
  const { getAccessTokenSilently } = useAuth0();

  const id = useId();
  const {
    tooltipText,
    position,
    visible,
    showTooltip,
    moveTooltip,
    hideTooltip,
  } = useToolTip();
  const [showOptions, setShowOptions] = React.useState<boolean>(false);
  const [isLike, setLike] = React.useState<boolean>(false);
  const [isDisLike, setIsDisLike] = React.useState<boolean>(false);
  const [isDisLikeFlag, setIsDisLikeFlag] = React.useState<boolean>(false);
  const [isCopy, setCopy] = React.useState<boolean>(false);
  const [popupPosition, setPopupPosition] = React.useState({
    top: "0px",
    left: "0px",
  });
  const [hoveredCopy, setHoveredCopy] = React.useState(false);
  const [hoveredShared, setHoveredShared] = React.useState(false);
  const [hoveredLiked, setHoveredLiked] = React.useState(false);
  const [hoveredDis, setHoveredDis] = React.useState(false);
  const [isGraphPopupOpen, setIsGraphPopupOpen] = React.useState(false);

  const dislikeHandler = (event: React.MouseEvent) => {
    if (isLike) return;
    setIsDisLikeFlag(true);
    setIsDisLike(!isDisLike);
    const iconPosition = (event.target as HTMLElement).getBoundingClientRect();
    setPopupPosition({
      top: `${iconPosition.top - 150}px`,
      left: `${iconPosition.left - 30}px`,
    });
  };
  const copyHandler = (message) => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
    copyText(message);
  };
  const shareHandler = () => {
    setShowOptions(true);
  };
  const likeHandler = async () => {
    if (isDisLike) return;
    const newLikeStatus = !isLike;
    setLike(newLikeStatus);
    
    if (newLikeStatus) {
      const payload = {
        thumbs_up: true,
        thumbs_down: false,
        request_not_understood: false,
        response_not_correct: false,
        response_not_complete: false,
        harmful_content: false,
        text_response: ""
      };
      
      try {
        const token = await getAccessTokenSilently();
        const msgId = message?.id || message?.assignedId || message?.thread_ts || "unknown";
        await ChatApiServices.saveFeedbackResponse(msgId, payload, token);
      } catch (error) {
        console.error("Error saving positive feedback:", error);
      }
    }
  };

  const graphCopy = (e) => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
    if (copyToClipBoard) {
      copyToClipBoard(e);
    }
  };
  const closePopupAndDislike = async (selectedOptions: string[] = [], description: string = "") => {
    setIsDisLike(true);
    setIsDisLikeFlag(false);
    
    const payload = {
      thumbs_up: false,
      thumbs_down: true,
      request_not_understood: selectedOptions.includes("Request not understood"),
      response_not_correct: selectedOptions.includes("Response not correct"),
      response_not_complete: selectedOptions.includes("Response not complete"),
      harmful_content: selectedOptions.includes("Harmful content"),
      text_response: description || ""
    };
    
    try {
      const token = await getAccessTokenSilently();
      const msgId = message?.id || message?.assignedId || message?.thread_ts || "unknown";
      await ChatApiServices.saveFeedbackResponse(msgId, payload, token);
    } catch (error) {
      console.error("Error saving negative feedback:", error);
    }
  };
  const closepopup = () => {
    setIsDisLikeFlag(false);
    setIsDisLike(false);
  };
  const closeShareOptions = () => {
    setShowOptions(false);
  };

  const handleDocumentLinksClick = async () => {
    const source = Array.isArray(message?.source) ? message.source[0] : message?.source;
    const fileName = typeof source === "object"
      ? source?.filename || source?.file_name || source?.name
      : typeof source === "string"
        ? source.split(/,(?![^()]*\))/)[0].trim().replace(/\s*\([^)]*\)$/, "")
        : message?.graph_data?.documents?.[0]?.name || message?.graph_data?.documents?.[0]?.file_name;

    try {
      const token = await getAccessTokenSilently();
      const response = fileName
        ? await getDocumentLinksByFilename<any>(fileName, message?.user_query || "", 1, token)
        : null;
      let documents: any[] = [];

      if (Array.isArray(response?.document_result)) {
        documents = response.document_result;
      } else if (Array.isArray(response)) {
        documents = response;
      } else if (Array.isArray(response?.documents)) {
        documents = response.documents;
      } else if (Array.isArray(response?.linked_documents)) {
        documents = response.linked_documents;
      } else if (Array.isArray(response?.data)) {
        documents = response.data;
      } else if (response?.results) {
        if (Array.isArray(response.results)) {
          documents = response.results;
        } else {
          const names = response.results.top_k_filenames || response.results.documents || [];
          const metadata = response.results.top_k_metadata || response.results.metadata || [];
          const urls = response.results.downloadable_url || response.results.urls || [];
          documents = names.map((name: any, index: number) => ({
            ...(typeof name === "string" ? { file_name: name } : name),
            ...(metadata[index] || {}),
            downloadable_url: urls[index] || metadata[index]?.downloadable_url || "",
          }));
        }
      }

      if (documents.length === 0) {
        documents = message?.graph_data?.documents || [];
      }

      updateState("docLinkSidebarData", documents.map((document: any) => ({
        ...document,
        name: document?.file_name || document?.name || document?.title || document,
        url: document?.downloadable_url || document?.url || document?.file_url || "",
      })));
    } catch (error) {
      console.error("Error fetching document links:", error);
      updateState("docLinkSidebarData", message?.graph_data?.documents || []);
    }

    updateState("isDocLinkSidebarOpen", true);
    updateState("isKgSidebarOpen", false);
  };

  const handleGraphClick = () => {
    if (!isKgChat) {
      void handleDocumentLinksClick();
      return;
    }
    setIsGraphPopupOpen((isOpen) => !isOpen);
  };








  return (
    <div className="messageFooter">
      <div className="footer chatfootericon chatfooter-relative">
        <ToolTipComponent
          text={tooltipText}
          position={position}
          visible={visible}
          marginLeft={70}
          marginTop={10}
          isPositionSet={false}
        />
        <div className="icon-left">
          {isCopy ? (
            <img
              className="icon tick"
              width={"25"}
              height={"25"}
              alt="avatar"
              src={"svg/action-icons/copy confirmed.svg"}
              onMouseEnter={(event) => showTooltip("Copy", event)}
              onMouseMove={(event) => moveTooltip(event)}
              onMouseLeave={hideTooltip}
            ></img>
          ) : (
            <span
              onClick={
                type == "graphs" ? graphCopy : () => copyHandler(message.text)
              }
            >
              <img
                className="icon"
                width={"13"}
                height={"13"}
                alt="avatar"
                src={hoveredCopy ? "svg/hover/Copy.svg" : "svg/Copy.svg"}
                onMouseEnter={(event) => {
                  showTooltip("Copy", event);
                  setHoveredCopy(true);
                }}
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={() => {
                  hideTooltip();
                  setHoveredCopy(false);
                }}
              />
            </span>
          )}
          <span onClick={shareHandler}>
            <img
              className="icon share-icon"
              width={"13"}
              height={"13"}
              alt="avatar"
              src={hoveredShared ? "svg/hover/share.svg" : "svg/share.svg"}
              onMouseEnter={(event) => {
                showTooltip("share", event);
                setHoveredShared(true);
              }}
              onMouseMove={(event) => moveTooltip(event)}
              onMouseLeave={() => {
                hideTooltip();
                setHoveredShared(false);
              }}
            />
          </span>
          <span 
            onClick={isDisLike ? undefined : likeHandler}
            style={{ opacity: isDisLike ? 0.5 : 1, cursor: isDisLike ? "not-allowed" : "pointer" }}
          >
            {isLike ? (
              <img
                className="icon tick"
                width={"13"}
                height={"13"}
                alt="avatar"
                src={"svg/action-icons/Thumbsup confirm.svg"}
                onMouseEnter={(event) =>
                  showTooltip("Positive feedback", event)
                }
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={hideTooltip}
              />
            ) : (
              <img
                className="icon"
                width={"13"}
                height={"13"}
                alt="avatar"
                src={
                  hoveredLiked ? "svg/hover/Thumbsup.svg" : "svg/Thumbsup.svg"
                }
                onMouseEnter={(event) => {
                  showTooltip("Positive feedback", event);
                  setHoveredLiked(true);
                }}
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={() => {
                  hideTooltip();
                  setHoveredLiked(false);
                }}
              />
            )}
          </span>
          <span 
            onClick={isLike ? undefined : dislikeHandler} 
            onMouseDown={(e) => e.stopPropagation()}
            style={{ opacity: isLike ? 0.5 : 1, cursor: isLike ? "not-allowed" : "pointer" }}
          >
            {isDisLike ? (
              <img
                data-id={id}
                className="icon tick"
                width={"13"}
                height={"13"}
                alt="Dislike active"
                src={"svg/action-icons/Thumbsdown confirm.svg"}
                onMouseEnter={(event) =>
                  showTooltip("Negative feedback", event)
                }
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={hideTooltip}
              />
            ) : (
              <img
                data-id={id}
                className="icon"
                width={"13"}
                height={"13"}
                alt="Dislike"
                src={
                  hoveredDis ? "svg/hover/Thumbsdown.svg" : "svg/Thumbsdown.svg"
                }
                onMouseEnter={(event) => {
                  showTooltip("Negative feedback", event);
                  setHoveredDis(true);
                }}
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={() => {
                  hideTooltip();
                  setHoveredDis(false);
                }}
              />
            )}
          </span>
          {isDisLike && isDisLikeFlag ? (
            <div>
              <FeedbackPopup
                isVisible={isDisLikeFlag && isDisLike}
                onClose={closepopup}
                onCloseAndDislike={closePopupAndDislike}
                position={popupPosition}
              />
            </div>
          ) : null}
          {isKgraph ? (
            <span
              className="graph-icon"
              onClick={handleGraphClick}
            >
              <img
                className="icon icon-small"
                width={"13"}
                height={"13"}
                alt="graph"
                src={"svg/KGicon.svg"}
                onMouseEnter={(event) => showTooltip("Graph", event)}
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={hideTooltip}
              />
            </span>
          ) : null}

        </div>

        {isKgChat && isGraphPopupOpen ? <KgGraphPopup graphData={message?.graph_data} /> : null}


        {showOptions ? (
          <div
            className="selectChartType"
            onMouseEnter={() => setShowOptions(true)}
            onMouseLeave={closeShareOptions}
          >
            <ul>
              <li>
                <Mail
                  bodyMsg={type == "graphs" ? "image graph" : message.text}
                />
              </li>
              <li>Print</li>
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MessageFooter; 